import http from './httpClient';

export const userApi = {
  myEvents:     ()              => http.get('/my-events'),
  list:         (role, eventId) => http.get(`/users?role=${role || ''}&event_id=${eventId || ''}`),
  invite:       (data)          => http.post('/users/invite', data),
  update:       (id, data)      => http.put(`/users/${id}`, data),
  deactivate:   (id)            => http.delete(`/users/${id}`),
  resetPassword:(id, pwd)       => http.put(`/users/${id}/password`, { new_password: pwd }),
  assignZones:  (eventId, userId, zoneIds) =>
    http.post(`/events/${eventId}/volunteers/${userId}/zones`, { zone_ids: zoneIds }),
  myZones:      (eventId)       => http.get(`/events/${eventId}/my-zones`),
};
